import configs from '../constants/configs';
import eventService from './eventService';
import { request } from './request';
import { ERR_VERSION_HISTORY_LATEST_ITEM } from '../constants/Errors';

/**
 * This function gets the latest version history item meta data and blocks
 * @param {string} documentID - Document identification composed of ${d:t}${draftID}${versionID}${trackID}
 * @return {object} - Latest item meta data and blocks
 */
export default async (documentID: string) => {
    // has to be outside of a useCallback
    try {
        const versionHistory = await request.get(`${configs.versionHistory}?documentID=${documentID}&quantity=1`);
        if (versionHistory.length === 0 || typeof versionHistory[Symbol.iterator] !== 'function') {
            return {};
        }

        const [latestItem] = versionHistory;
        const { versionID } = latestItem;
        const { blocks } = await request.get(`${configs.versionHistoryItem}?documentID=${documentID}&versionID=${versionID}`);

        return { ...latestItem, blocks: JSON.parse(blocks) };
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
        eventService.notify(err.customMessage ? err.customMessage : ERR_VERSION_HISTORY_LATEST_ITEM, true);
        return {};
    }
};
